
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 28 28"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16 18a1 1 0 011 1v4h-2v-4a1 1 0 011-1zm6-2a1 1 0 011 1v6h-2v-6a1 1 0 011-1zm-3-2a1 1 0 011 1v8h-2v-8a1 1 0 011-1zm-4.466-8.739l.087.066 6.93 5.943a.893.893 0 01-1.073 1.424l-.09-.068-6.348-5.443-6.254 5.379v8.53h4.116c.458 0 .836.346.888.79l.006.104a.893.893 0 01-.79.887l-.104.006H6.893a.893.893 0 01-.887-.789L6 21.986v-9.834c0-.223.083-.436.231-.6l.08-.077 7.146-6.147a.893.893 0 011.077-.067z"}})])
          )
        }
      }
    